<template>
    <div class="faqvalue">
        <div class="faqnav" id='myfaqnav' :class='{isFaqnavabsolute:!state,isFaqnavfiex:state,isOpctiy:opctiy}'
            :style='{top:faqnavtop+"px"}'>
            <FAQnavChild ref='faqchildNav'></FAQnavChild>
        </div>
        <div class="faqvalue-box" id='mybox'>
            <div class="faqvalue-item-box" v-for='(item,index) in valueData' :key='index' :id='"item"+index'>
                <h4 class="itmecaption">{{item.name}}</h4>
                <ul class="item-ui">
                    <h4 class="itmecaption1">{{item.name}}</h4>
                    <li class="item-li" v-for='(childitem,childindex) in childData[index]' :key='childindex'>
                        <h5 class="childCaption">{{childitem.problem}}</h5>
                        <div class="childValue" v-html='childitem.answer'></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import FAQnavChild from '@/components/main/faq/faqnavchild'//列表
    export default {
        name: 'FaqValue',
        components: {
            FAQnavChild
        },
        data() {
            return {
                state: false,
                count: false,//是否记录
                opctiy: false,//是否隐藏
                anchor: '',//记录距离顶部的值
                faqnavtop: '-104',//子导航绑定的数据
                navHeightdata: '',//头部导航的高度获取值
                valueData: [],//标题内容
                childData: [],//每一项的内容
            }
        },
        mounted() {
            this.getChildNav()
            this.getnavHeight()
        },
        methods: {
            faqnavmove() {
                const that = this
                let nav = document.querySelector('#topnavbar')//导航条
                let faqtop = document.querySelector('#myfaqnav')//悬浮导航
                let box = document.querySelector('#mybox')//问题内容
                const navbar = nav.getBoundingClientRect()
                const offset = faqtop.getBoundingClientRect() // vue中，使用this.$el获取当前组件的根元素
                const boxOffset = box.getBoundingClientRect()
                if (offset.top <= that.navHeightdata) {
                    //改变模块的定位状态
                    that.faqnavtop = that.navHeightdata
                    if (that.count) {//已经记录值
                        if (boxOffset.top > that.anchor) {//判断当前内容的位置是否在记录值的下方
                            that.state = false
                            that.count = false
                            that.anchor = ''//清除已经记录的内容
                            this.relation(offset.height)
                        } else {
                            this.relation(offset.height)
                        }
                    } else {//没有记录值
                        that.count = true
                        that.state = true//改变侧边导航的状态
                        that.anchor = boxOffset.top//记录内容到视口顶部的距离
                        this.relation(offset.height)
                    }
                } else {
                    that.faqnavtop = '-104'
                }
                this.relationitem()//判断模块的位置进行改变导航的内容
            },
            relation(height) {//判断导航和最后一个子元素的位置关系
                let that = this
                let itembox = document.querySelector('.faqvalue-box')
                const lastItemBox = this.lastChild(itembox)
                const lastoffset = lastItemBox.getBoundingClientRect()
                if (lastoffset.bottom <= height) {
                    that.opctiy = true
                } else {
                    that.opctiy = false
                }

            },
            lastChild(obj) {
                return obj.lastElementChild ? obj.lastElementChild : obj.lastChild
            },
            relationitem() {//判断模块内容的位置区域
                let _this = this
                const itemArr = document.getElementsByClassName('faqvalue-item-box')
                for (var i = 0; i <= itemArr.length - 1; i++) {
                    _this.moveMethods(itemArr[i], i)
                }
                // console.log(itemArr.length-1)
                // for(var i=0;i++;i<=itemArr.length){
                //     // _this.moveMethods(itemArr[i],i)
                //     console.log(i)
                // }
            },
            moveMethods(conter, num) {//模块内容移动时
                let that = this
                const windowheight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                let offsetTop = conter.getBoundingClientRect().top
                if (offsetTop <= (windowheight / 2) && offsetTop >= 0) {
                    that.changeIsActive(num)
                }
            },
            changeIsActive(num) {
                this.$refs.faqchildNav.isClick(num)
            },
            pathTo(id) {
                const itemArr = document.getElementsByClassName('faqvalue-item-box')
                itemArr[id].scrollIntoView({ block: "start", behavior: "smooth" })
            },
            getnavHeight() {
                let navelem = document.querySelector('#topnavbar')
                const navHeight = navelem.getBoundingClientRect().height
                this.navHeightdata = navHeight
            },
            getChildNav() {
                this.$axios.get(this.$API.thoreGetProblem)
                    .then(res => {
                        this.valueData = res.data.data
                        this.getChildItem(0)
                    })
                    .catch(err => {
                        this.$message.error('网络波动，请刷新重试')
                    })
            },
            getChildItem(index) {
                this.$axios.get(this.$API.thoreGetProblems, {
                    params: {
                        problem_type_id: this.valueData[index].id
                    }
                })
                    .then(res => {
                        this.childData.push(res.data.data)
                        if (index < this.valueData.length) {
                            this.getChildItem(index+1)
                        }
                    })
                    // .catch(err => {
                    //     this.$message.error('网络波动获取失败，请刷新重试')
                    // })
            }
        }
    }
</script>
<style scoped>
    .faqvalue-box {
        padding: 181px 0;
        display: flex;
        flex-direction: column;
        -ms-flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        position: relative;
    }

    .faqvalue {
        position: relative;
    }

    .faqnav {
        width: 24.1%;
        min-height: 549px;
        padding:5%;
        background-color: #1c1c1c;
        /* position: absolute;
        top: -104px;
        left: 140px; */
        z-index: 5;
        transition: all 0.5s;
        opacity: 1;
    }

    .isOpctiy {
        opacity: 0;
    }

    .isFaqnavabsolute {
        position: absolute;
        top: -104px;
        left: 7.2%;
    }

    .isFaqnavfiex {
        position: fixed;
        top: 0;
        left: 7.2%;
    }

    .faqvalue-item-box {
        width: 78.3%;
        background-color: #ffffff;
        padding: 142px 140px 182px 32%;
        position: relative;
    }

    .faqvalue-item-box:not(:last-child) {
        margin-bottom: 155px;
    }

    .childCaption {
        font-size: 16px;
        font-weight: bold;
        line-height: 137.5%;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 16px;
    }

    .childValue {
        font-size: 14px;
        font-weight: 400;
        line-height: 142%;
        color: rgba(153, 153, 153, 1);
    }

    .item-li {
        padding-bottom: 26px;
        border-bottom: 1px solid #F1F1F1;
    }

    .item-li:not(:first-child) {
        padding-top: 37px;
    }

    .itmecaption {
        width: 20px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        writing-mode: vertical-rl;
        color: rgba(28, 28, 28, 1);
        position: absolute;
        top: 142px;
        left: 18%;
    }

    .itmecaption::after {
        content: '';
        display: block;
        height: 45px;
        width: 1px;
        background-color: #000000;
        position: absolute;
        left: 50%;
        bottom: 0;
        border: none;
        transform: translate(-50%, 130%);
    }
    .itmecaption1{
        display: none;
    }
    @media(max-width: 995px){
        .faqnav {
            display: none;
        }
        .faqvalue-item-box {
            width: 100%;
            padding:5%;
        }
        .itmecaption1{
            display: block;
            font-size: 24px;
        }
        .itmecaption{
            display: none;
        }
        .childCaption {
            font-size: 24px;
        }

        .childValue {
            font-size: 16px;
        }
        .faqvalue .faqvalue-box {
        padding:0px;
    }
    .faqvalue-item-box:not(:last-child) {
        margin-bottom:5%;
    }
    }

    /* @media(max-width: 1023px) {
        .faqnav {
            display: none;
        }

        .childCaption {
            font-size: 60px;
        }

        .childValue {
            font-size: 60px;
        }

        .faqvalue-item-box {
            width: 100%;
            padding:5%;
        }
        .itmecaption1{
            display: block;
            font-size: 75px;
        }
        .itmecaption{
            display: none;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/faq/faq.vue